import { cn } from "@utils";
import {
  DEFAULT_WORKING_SET_COLOUR,
  DEFAULT_WORKING_SET_ICON,
  WORKING_SET_COLOURS,
  WORKING_SET_ICONS,
} from "../hooks/workingSets";

const WorkingSetIcon = ({ icon, colour, className, iconClassName }) => {
  const Icon = WORKING_SET_ICONS[icon] ?? WORKING_SET_ICONS[DEFAULT_WORKING_SET_ICON];
  const tone = WORKING_SET_COLOURS[colour] ?? WORKING_SET_COLOURS[DEFAULT_WORKING_SET_COLOUR];
  return (
    <span className={cn("flex size-8 shrink-0 items-center justify-center rounded-lg", tone.tile, className)}>
      <Icon aria-hidden="true" className={cn("size-4", iconClassName)} />
    </span>
  );
};

export default WorkingSetIcon;
